(function cartStickerOfferControllerFactory(root) {
  'use strict';

  const stickerOfferSource = 'sticker-offer';

  function findStickerLineKey(cart, variantId) {
    const numericVariantId = Number(variantId);
    const line = (Array.isArray(cart?.items) ? cart.items : [])
      .find((item) => Number(item?.variant_id) === numericVariantId);

    return line?.key || '';
  }

  function parseCartError(error) {
    if (!error) {
      return '';
    }

    if (typeof error === 'string') {
      return error;
    }

    return error.description || error.message || '';
  }

  function dispatchStickerUpdated(cart) {
    if (
      !root.document
      || !cart
      || typeof root.document.dispatchEvent !== 'function'
      || typeof root.CustomEvent !== 'function'
    ) {
      return;
    }

    root.document.dispatchEvent(new root.CustomEvent('cart:updated', {
      detail: {
        cart,
        openDrawer: false,
        source: stickerOfferSource,
      },
    }));
  }

  async function toggleStickerLine({ variantId, lineKey, added }, inventory = root.cartInventory) {
    if (!inventory) {
      throw new Error('');
    }

    if (added) {
      const result = await inventory.changeLine(lineKey, 0);
      return { ...result, lineKey: findStickerLineKey(result.cart, variantId) };
    }

    const result = await inventory.addVariant({ id: Number(variantId), quantity: 1 });
    return { ...result, lineKey: findStickerLineKey(result.cart, variantId) };
  }

  function registerAlpine() {
    if (!root.Alpine) {
      return;
    }

    root.Alpine.data('stickerOffer', (config = {}) => ({
      variantId: config.variantId || null,
      lineKey: config.lineKey || '',
      added: Boolean(config.added),
      errorMessage: config.errorMessage || '',
      error: '',
      pending: false,
      dismissed: false,

      async toggle() {
        if (this.pending || !this.variantId) {
          return;
        }

        this.pending = true;
        this.error = '';

        try {
          const result = await toggleStickerLine({
            variantId: this.variantId,
            lineKey: this.lineKey,
            added: this.added,
          });
          this.lineKey = result.lineKey;
          this.added = result.lineKey !== '';
          this.error = result.message || '';
          dispatchStickerUpdated(result.cart);
        } catch (error) {
          this.error = parseCartError(error) || this.errorMessage;
          if (error?.cart) {
            this.lineKey = findStickerLineKey(error.cart, this.variantId);
            this.added = this.lineKey !== '';
          }
        } finally {
          this.pending = false;
        }
      },
    }));
  }

  if (root.document) {
    root.document.addEventListener('alpine:init', registerAlpine);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      findStickerLineKey,
      stickerOfferSource,
      toggleStickerLine,
    };
  }
}(typeof window !== 'undefined' ? window : globalThis));
